import React from "react";
import { ArrowUpRight } from "lucide-react";
import { travel } from "../mock";
import useReveal from "../hooks/useReveal";

function renderBold(text) {
  const parts = text.split(/(\*\*[^*]+\*\*)/g);
  return parts.map((p, i) =>
    p.startsWith("**") && p.endsWith("**") ? (
      <strong key={i} className="text-[#211E1A] font-semibold">{p.slice(2, -2)}</strong>
    ) : (
      <span key={i}>{p}</span>
    )
  );
}

export default function Travel() {
  const [ref, visible] = useReveal();
  return (
    <section id="travel" className="relative">
      {/* Options band */}
      <div className="bg-[#ECE3D4] py-24 md:py-32 px-6">
        <div ref={ref} className={`max-w-[1150px] mx-auto reveal ${visible ? "is-visible" : ""}`}>
          <h2 className="text-center font-serif-display text-[#9E2B25] text-[46px] md:text-[68px] mb-16">
            {travel.title}
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8">
            {travel.options.map((o, i) => (
              <div key={i} className="text-center px-4">
                <h3 className="font-serif-display text-[32px] md:text-[38px] text-[#211E1A]">{o.mode}</h3>
                <p className="mt-4 text-[#4a443d] leading-relaxed">{renderBold(o.text)}</p>
                <a
                  href={o.mapUrl}
                  target="_blank"
                  rel="noreferrer"
                  className="mt-5 inline-flex items-center gap-1 text-[#9E2B25] link-underline text-sm"
                >
                  View on map <ArrowUpRight size={15} />
                </a>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
